// AD-2717: who recorded a medical event or note and when, and who last changed it. Shown to everyone who can see
// the section; it cannot be changed.

const when = (value) => new Date(value).toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit'
});

export const recordedLine = (entry) => {
    if (!entry?.recordedAt) return '';
    if (entry.addedInSims) return `Added in SIMS on ${when(entry.recordedAt)}`;
    if (!entry.recordedBy) return '';

    return `Recorded by ${entry.recordedBy} on ${when(entry.recordedAt)}`;
};

export const editedLine = (entry) => entry?.lastEditedBy && entry?.lastEditedAt
    ? `Last edited by ${entry.lastEditedBy} on ${when(entry.lastEditedAt)}`
    : '';
